import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    arrow:
      'absolute top-1/2 hidden size-12 -translate-y-1/2 transform cursor-pointer bg-white/60 p-0 text-black lg:block'
  }
});
